import apiBase from './apiBase';

class AuthenticationApi {
  static signIn(signInData) {
    return apiBase.post('/participant-accounts/authenticate', signInData);
  }

  static signOut() {
    return apiBase.post('/participant-accounts/sign-out');
  }

  static register(data) {
    return apiBase.post('/participant-accounts/register', data);
  }

  static recoverPassword(recoverPasswordData) {
    return apiBase.post('/participant-accounts/recover-password', recoverPasswordData);
  }

  static activateAccount(activationData) {
    return apiBase.post('/participant-accounts/activate-account', activationData);
  }

  static resetPassword(resetPasswordData) {
    return apiBase.post('/participant-accounts/set-password', resetPasswordData);
  }

  static me() {
    return apiBase.get('/participant-accounts/me');
  }

  static updateProfile(data) {
    return apiBase.put('/participant-accounts/me', data);
  }

  static updateSettings(data) {
    return apiBase.put('/participant-accounts/me/settings', data);
  }

  static deleteAccountByParticipant() {
    return apiBase.delete('/participant-accounts/me');
  }

  static wkSignIn() {
    return apiBase.post('/participant-accounts/gov/register', {});
  }
}

export default AuthenticationApi;



// WEBPACK FOOTER //
// ./src/api/authenticationApi.js